'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import type React from 'react';
import { useState } from 'react';
import { usePreventBodyScroll } from '../../common/hooks/usePreventBodyScroll';

interface BoostingPerformanceInfoBottomSheetProps {
  children: React.ReactNode;
}

export const BoostingPerformanceInfoBottomSheet = ({
  children,
}: BoostingPerformanceInfoBottomSheetProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // 바텀시트 열렸을 때 뒤쪽 스크롤 방지
  usePreventBodyScroll({ open: isOpen });

  return (
    <Sheet direction="bottom" defaultOpen={false} open={isOpen}>
      <SheetTrigger asChild onClick={() => setIsOpen(true)}>
        {children}
      </SheetTrigger>
      <SheetPortal>
        <SheetContent onPointerDownOutside={() => setIsOpen(false)}>
          <SheetMotion direction="bottom">
            <BottomSheetTitle>
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer>
                <BottomSheetTitleBox className="py-3">
                  <Typography size="18" weight="medium">
                    수수료 부스트 프로모션 실적 안내
                  </Typography>
                </BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={() => setIsOpen(false)}>
                  <IcDelete />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <BoostingPerformanceInfoBottomSheetContent />
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};

const BoostingPerformanceInfoBottomSheetContent = () => (
  <div className="flex flex-col px-4 bg-white safe-area-bottom">
    <div className="flex flex-col pb-[12px]!">
      <ul>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            수수료 부스트 프로모션에 대한 실적입니다.
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            예상 수익은 프로모션 참여 추가 수수료의 반영된 추가 수익입니다.
          </Typography>
        </li>
        <li className="flex gap-[4px] py-1">
          <Typography colorScheme="gray-600" variant="body13pxReg">
            •
          </Typography>
          <Typography colorScheme="gray-600" variant="body13pxReg">
            동일 기간에 두 개 이상의 프로모션에 중복 참여한 경우 수 추가수익은 중복되어 적용되지
            않습니다.
          </Typography>
        </li>
      </ul>
    </div>
  </div>
);
